declare const __SPA__: boolean | undefined

const spa = typeof __SPA__ !== 'undefined' && __SPA__

function viteEnv(key: keyof ImportMetaEnv): string | undefined {
  const value = import.meta.env[key]
  return typeof value === 'string' ? value : undefined
}

export const isSpa = spa

export const isDev = spa ? import.meta.env.DEV : process.env.NODE_ENV === 'development'

export const isMockApi = spa
  ? viteEnv('VITE_MOCK_API') === 'true'
  : process.env.NEXT_PUBLIC_MOCK_API === 'true'

export const enableHandoverSimulation = spa
  ? viteEnv('VITE_ENABLE_HANDOVER_SIMULATION') === 'true'
  : process.env.NEXT_PUBLIC_ENABLE_HANDOVER_SIMULATION === 'true'

export const appMode = (
  spa
    ? viteEnv('VITE_APP_MODE') === 'delman'
      ? 'delman'
      : 'kitchen'
    : process.env.NEXT_PUBLIC_APP_MODE === 'delman'
      ? 'delman'
      : 'kitchen'
) as 'kitchen' | 'delman'

export const apiBaseUrl = spa
  ? (viteEnv('VITE_API_URL') ?? 'http://localhost:8080/api/v1')
  : (process.env.NEXT_PUBLIC_API_URL ?? 'http://localhost:8080/api/v1')

export const publicApiOrigin = apiBaseUrl.replace(/\/api\/v1\/?$/, '')
